import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import firebase from 'firebase';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class RecurlyService {
  constructor(private http: HttpClient) {}

  updateUserRecurlyCode(userdocid: string, recurlyaccountcode: string, plancode: string) {
    return firebase.functions().httpsCallable('recurly-updateUserRecurlyCode')({
      userdocid,
      recurlyaccountcode,
      plancode,
    });
  }

  async getPlanRestrictions(planDocId: any) {
    const planData = (
      await firebase
        .firestore()
        .doc('plans/' + planDocId)
        .get()
    ).data();
    return planData ? planData['upgrade'] : false;
  }

  getSubscriptionId(accountData: {}): any {
    console.log('accountData :', accountData);
    throw new Error('Method not implemented.');
  }

  /**
   * Recurly HTTP functions. A local environment can set `constants.recurlyFunctionsURL` to point only these calls at
   * another project (for example a Recurly sandbox deployed in the test project). In that case the Firebase ID token is
   * sent, because those functions verify it.
   */
  private async callRecurly(name: string, query: Record<string, string>): Promise<any> {
    const override = (environment.constants as any).recurlyFunctionsURL as string | undefined;
    const base = override || environment.constants.cloudfunctionsURL;
    const qs = Object.keys(query)
      .map(k => `${k}=${encodeURIComponent(query[k])}`)
      .join('&');
    const url = `${base}${name}?${qs}`;
    if (!override) {
      return this.http.get(url).toPromise();
    }
    const user = firebase.auth().currentUser;
    const token = user ? await user.getIdToken() : null;
    const headers = token ? new HttpHeaders().set('Authorization', `Bearer ${token}`) : new HttpHeaders();
    return this.http.get(url, { headers }).toPromise();
  }

  getSubscriptions(accountId): any {
    return this.callRecurly('recurly-getSubscriptions', { accountid: accountId });
  }

  changeSubscriotion(subscriptionId: any, newplan: any) {
    return this.callRecurly('recurly-changeSubscription', { subscriptionid: subscriptionId, newplancode: newplan });
  }

  getAccount(accountcode) {
    return this.callRecurly('recurly-getAccount', { accountcode });
  }
}
